import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControlLabel,
    Switch,
    CardActions
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function QuickShippingCard({ value, handleChange }) {
    const { t } = useTranslation();
    return (
        <Card>
            <CardHeader title={t("Express shipping")} />
            <Divider />
            <CardContent>
                <FormControlLabel
                    control={
                        <Switch
                            checked={value}
                            onChange={(event) => handleChange({ target: { name: "quickShipping", value: event.target.checked } })}
                        />}
                    label={t(value ? "Activated" : "Not Activated")} />
            </CardContent>
        </Card>
    );
};

